var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.75C9.22587 13.75 10.7884 13.0504 11.9194 11.9194C13.0504 10.7884 13.75 9.22587 13.75 7.5C13.75 5.77413 13.0504 4.21162 11.9194 3.08058C10.7884 1.94956 9.22587 1.25 7.5 1.25C5.77413 1.25 4.21162 1.94956 3.08058 3.08058C1.94956 4.21162 1.25 5.77413 1.25 7.5C1.25 9.22587 1.94956 10.7884 3.08058 11.9194C4.21162 13.0504 5.77413 13.75 7.5 13.75Z",
    stroke: "currentColor",
    strokeWidth: 1.625,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.4375C7.93147 3.4375 8.28125 3.78728 8.28125 4.21875C8.28125 4.65022 7.93147 5 7.5 5C7.06853 5 6.71875 4.65022 6.71875 4.21875C6.71875 3.78728 7.06853 3.4375 7.5 3.4375Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65625 10.625V6.25H7.34375H7.03125",
    stroke: "currentColor",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 10.625H8.75",
    stroke: "currentColor",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.1a1f531f0e015da8dd10d38f58aa24e6.svg";
export { ForwardRef as ReactComponent };